import {
  NavigateEditPageButton,
  NotFound,
  PageContent,
  PageHeader,
  Space,
} from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useCreateBreadcrumbs } from '@/hooks/creaet-breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { NavigationLabelButton } from './_components/NavigationLabelButton';
import { CreateOrganizationPage } from './_pages/CreateOrganizationPage';
import { OrganizationDetailsPage } from './_pages/OrganizationDetailsPage';
import { OrganizationsPage } from './_pages/OrganizationsPage';
import { UpdateOrganizationPage } from './_pages/UpdateOrganizationPage';

export const OrganizationRoutes = () => {
  const { t } = useTranslation();

  const { createBreadcrumb } = useCreateBreadcrumbs({ baseIndex: 3 });

  return (
    <Routes>
      <Route
        path="*"
        element={<NotFound showBackButton={false} height="100vh" />}
      />
      <Route
        index
        element={
          <>
            <PageHeader
              title={t('tenant-manager-root-page')}
              breadcrumbs={[{ title: t('tenant-manager-root-page') }]}
              buttons={<NavigationLabelButton />}
            />
            <PageContent>
              <OrganizationsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/new"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('create-organization-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
                { title: t('create-organization-page') },
              ])}
            />
            <PageContent>
              <CreateOrganizationPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/:id"
        element={
          <>
            <PageHeader
              title={t('organization-details-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
                { title: t('organization-details-page') },
              ])}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <Space>
                    <NavigateEditPageButton />
                  </Space>
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <OrganizationDetailsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/:id/edit"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('update-organization-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
                { title: t('organization-details-page') },
                { title: t('update-organization-page') },
              ])}
            />
            <PageContent>
              <UpdateOrganizationPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
    </Routes>
  );
};
